<template>
  <div>
    <!-- <PcIndex></PcIndex> -->
  </div>
</template>

<script>
// import PcIndex from "@/components/Pc";
export default {
  components: {
    // PcIndex,
  },
  data() {
    return {
      isWebp: false,
    };
  },
  setup() {},
  created() {},

  methods: {},
};
</script>

<style></style>
